import React, { useCallback } from 'react';
import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';
import useStyles from './styles';
import { User } from '../../../types/items';
import { SimpleButton } from '../../../components';
import history from '../../../history';

type Props = {
  user: User | null;
  withNavigator?: boolean;
};

const RemainingCreditsTip = ({ user, withNavigator = false }: Props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const remaining = user?.ref?.active_subscription?.video_credits_balance || 0;

  const clickHandler = useCallback(() => {
    if (history.location.pathname.search('profile') !== -1) {
      dispatch(push('/dashboard/profile/billing/credit-history'));
    } else {
      dispatch(push(`/dashboard/admin/users/${user?.id}/billing/credit-history`));
    }
  }, [dispatch, user]);

  return (
    <div className={classes.container}>
      <div className={classes.title}>Remaining Video Credits</div>
      <div className={classes.creditCounter}>{remaining}</div>
      {withNavigator
        && (
          <SimpleButton onClick={clickHandler} additionalClassName={classes.button}>
            Credit History
          </SimpleButton>
        )}
    </div>
  );
};

export default RemainingCreditsTip;
